import * as Yup from 'yup';

const ALPHABETICAL_REGEX: RegExp = /^[A-Za-z\s]+$/;
const CA_NAME_REGEX: RegExp = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/;
const ADDRESS_REGEX: RegExp = /^[A-Za-z0-9À-ÖØ-öø-ÿ\s.,#'-]+$/;
const CITY_REGEX: RegExp = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/;
const US_ZIP_REGEX: RegExp = /^\d{5}$/;
const CA_POSTAL_REGEX: RegExp = /^[A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d$/;
const US_MOBILE_NUMBER_REGEX: RegExp = /^[0-9]{10}$/;

export const personalInfomtaionFormValidationSchema = (isCanada: boolean) =>
  Yup.object({
    address1: Yup.string()
      .matches(ADDRESS_REGEX, 'registration.personal.information.address.error.invalid')
      .required('registration.personal.information.address.error.empty'),
    address2: Yup.string()
      .matches(ADDRESS_REGEX, 'registration.personal.information.address.2.error.invalid'),
    city: Yup.string()
      .matches(CITY_REGEX, 'registration.personal.information.city.error.invalid')
      .required('registration.personal.information.city.error.empty'),
    firstName: Yup.string()
      .matches(isCanada ? CA_NAME_REGEX : ALPHABETICAL_REGEX, 'registration.personal.information.firstName.error.invalid')
      .required('registration.personal.information.firstName.error.empty'),
    lastName: Yup.string()
      .matches(isCanada ? CA_NAME_REGEX : ALPHABETICAL_REGEX, 'registration.personal.information.lastName.error.invalid')
      .required('registration.personal.information.lastName.error.empty'),
    number: Yup.string()
      .matches(US_MOBILE_NUMBER_REGEX, 'registration.personal.information.mobileNumber.error.invalid')
      .required('registration.personal.information.mobileNumber.error.empty'),
    state: Yup.string()
      .required('registration.personal.information.state.error.empty'),
    zipCode: Yup.string()
      .matches(isCanada ? CA_POSTAL_REGEX : US_ZIP_REGEX, {
        message: 'registration.personal.information.zipCode.error.invalid',
        excludeEmptyString: true,
      })
      .required('registration.personal.information.zipCode.error.empty')
  });